/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_So_StatusInputs */

const en_reference_field_so_status = /** @type {(inputs: Reference_Field_So_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales order status`)
};

/**
* | output |
* | --- |
* | "Sales order status" |
*
* @param {Reference_Field_So_StatusInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_so_status = /** @type {((inputs?: Reference_Field_So_StatusInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_So_StatusInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_so_status(inputs)
});